import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/ForgotPassword";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { setError("Password must be at least 6 characters"); return; }
    if (pw !== pw2) { setError("Passwords don't match"); return; }
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password updated — sign in with your new password");
      navigate("/login");
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell>
      <h1 className="font-display text-2xl font-bold text-center">Choose a new password</h1>
      {!token ? (
        <p className="text-sm text-red-600 text-center mt-4" data-testid="reset-missing-token">This reset link is missing its code. <Link to="/forgot-password" className="text-ys-sky font-semibold">Request a new one</Link>.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div>
            <Label htmlFor="pw">New password</Label>
            <Input id="pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" className="mt-1.5 rounded-xl h-12" placeholder="At least 6 characters" />
          </div>
          <div>
            <Label htmlFor="pw2">Confirm new password</Label>
            <Input id="pw2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" className="mt-1.5 rounded-xl h-12" />
          </div>
          {error && (
            <p className="text-sm text-red-600" data-testid="reset-error">{error} {/expired|invalid|used/i.test(error) && <Link to="/forgot-password" className="text-ys-sky font-semibold">Request a new link</Link>}</p>
          )}
          <Button type="submit" disabled={loading} data-testid="reset-submit-btn" className="w-full rounded-full h-12 bg-ys-sky hover:bg-sky-700 text-base">
            {loading ? "Saving..." : "Update password"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
